import { useState, useEffect, type FunctionComponent } from 'react';
import { useSession } from 'next-auth/react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useNavigatorOnline } from '@oieduardorabelo/use-navigator-online';

const Tawk: FunctionComponent = () => {
  const [tawkLoaded, setTawkLoaded] = useState(false);
  const { data: session } = useSession();
  const onlineStatus = useNavigatorOnline();

  useEffect(() => {
    if (tawkLoaded && session?.user != null && onlineStatus.isOnline) {
      try {
        // @ts-expect-error
        window.Tawk_API?.setAttributes?.({
          name: `${session.user.givenName} ${session.user.surname}`,
          email: session.user.email,
        });
      } catch (error) {
        console.error('Error setting Tawk attributes:', error);
      }
    }
  }, [session?.user, tawkLoaded, onlineStatus.isOnline]);

  return (
    <>
      <TawkMessengerReact
        propertyId={process.env.NEXT_PUBLIC_TAWK_PROPERTY_ID}
        widgetId={process.env.NEXT_PUBLIC_TAWK_WIDGET_ID}
        onLoad={() => setTawkLoaded(true)}
      />
    </>
  );
};

export default Tawk;
